// extracted by mini-css-extract-plugin
export default {"line":"FormSeparator_line__EtpJn","boldLine":"FormSeparator_boldLine__gURs+"};